import $ from 'jquery';

const $countryPicker = $('.country-picker');

$countryPicker.each((i, el) => {
  const $el = $(el);
  const $btn = $el.find('.country-picker-btn');
  const $dropdown = $el.find('.country-picker-dropdown');
  let isOpen = false;

  function openDropdown() {
    isOpen = true;
    $el.addClass('is-open');
    $dropdown.attr('aria-hidden', false);
    $btn.attr('aria-expanded', true);
  }

  function closeDropdown() {
    isOpen = false;
    $el.removeClass('is-open');
    $dropdown.attr('aria-hidden', true);
    $btn.attr('aria-expanded', false);
  }

  $btn.click(e => {
    e.preventDefault();
    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });
});
